import { Grid, styled, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TIPOS_MENSAJES } from "../../Constants";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const VideoBubble = styled("div")(({ sent }) => ({
  backgroundColor: sent ? "#dcf8c6" : "#fff",
  padding: "4px",
  borderRadius: "7.5px",
  maxWidth: "330px",
  position: "relative",
  boxShadow: "0 1px 0.5px rgba(0,0,0,0.13)",
  marginBottom: "10px",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    width: 0,
    height: 0,
    border: "10px solid transparent",
    ...(sent
      ? {
          right: "-10px",
          borderLeftColor: "#dcf8c6",
          borderRight: 0,
          borderTop: 0,
        }
      : {
          left: "-10px",
          borderRightColor: "#fff",
          borderLeft: 0,
          borderTop: 0,
        }),
  },
}));

const VideoContainer = styled("div")({
  position: "relative",
  cursor: "pointer",
  "&:hover": {
    opacity: 0.9,
  },
});

const StyledVideo = styled("video")({
  width: "100%",
  maxHeight: "330px",
  objectFit: "cover",
  borderRadius: "4px",
  backgroundColor: "#000",
});

const PlayButton = styled(IconButton)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(0,0,0,0.5)",
  color: "#fff",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.7)",
  },
});

const MessageMeta = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  position: "absolute",
  bottom: "8px",
  right: "8px",
  backgroundColor: "rgba(0,0,0,0.3)",
  padding: "2px 6px",
  borderRadius: "12px",
});

const MessageTime = styled("span")({
  fontSize: "11px",
  color: "#fff",
});

const MessageTick = styled(DoneAllIcon)({
  fontSize: "16px",
  color: "#fff",
});

export default function Video({
  videKey,
  tipos,
  times,
  fetchMediaUrl,
  onClick,
}) {
  const [video, setVideo] = useState();
  const [isPlaying, setIsPlaying] = useState(false);
  const isSent = tipos === TIPOS_MENSAJES.enviado;
  const videoRef = React.useRef(null);

  useEffect(() => {
    if (videKey) {
      fetchMediaUrl(videKey, setVideo, ".mp4");
    }
  }, [videKey, fetchMediaUrl]);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <Grid
      container
      justifyContent={isSent ? "flex-end" : "flex-start"}
      sx={{ padding: "0 5%" }}
    >
      <VideoBubble sent={isSent}>
        <VideoContainer onClick={() => onClick && onClick(video)}>
          <StyledVideo
            ref={videoRef}
            src={video}
            onEnded={() => setIsPlaying(false)}
          />
          {!isPlaying && (
            <PlayButton onClick={handlePlayPause}>
              <PlayArrowIcon fontSize="large" />
            </PlayButton>
          )}
          <MessageMeta>
            <MessageTime>{times}</MessageTime>
            {isSent && <MessageTick />}
          </MessageMeta>
        </VideoContainer>
      </VideoBubble>
    </Grid>
  );
}
